import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import isFunction from "lodash/isFunction";

const google = window.google;

export const parsePlottedValues = (plottedValues) => {
  let obj = {
    attributeId: 91,
    values: {
      operator: "plotted_polygon",
      values: "",
    },
  };
  let value = null;
  switch (plottedValues.type) {
    case "rectangle":
      let aNorth = null;
      let aEast = null;
      let aSouth = null;
      let aWest = null;
      if (
        plottedValues.bounds &&
        typeof plottedValues.bounds.getNorthEast !== "undefined"
      ) {
        const nePoint = plottedValues.bounds.getNorthEast();
        const swPoint = plottedValues.bounds.getSouthWest();
        aNorth = nePoint.lat();
        aEast = nePoint.lng();
        aSouth = swPoint.lat();
        aWest = swPoint.lng();
      } else {
        aNorth = plottedValues.bounds.north;
        aEast = plottedValues.bounds.east;
        aSouth = plottedValues.bounds.south;
        aWest = plottedValues.bounds.west;
      }

      value = {
        coordinates: [
          [aWest, aNorth],
          [aEast, aNorth],
          [aEast, aSouth],
          [aWest, aSouth],
          [aWest, aNorth],
        ],
      };

      obj.values.operator = "plotted_square";
      obj.values.values = JSON.stringify(value);
      break;
    case "circle":
      obj.values.operator = "plotted_radius";
      value = {
        lat: isFunction(plottedValues.center.lat)
          ? plottedValues.center.lat()
          : plottedValues.center.lat,
        lng: isFunction(plottedValues.center.lng)
          ? plottedValues.center.lng()
          : plottedValues.center.lng,
        radius: plottedValues.radius,
      };
      obj.values.values = JSON.stringify(value);
      break;
    case "polygon":
      const path =
        typeof plottedValues.path === "string"
          ? google.maps.geometry.encoding.decodePath(plottedValues.path)
          : plottedValues.path;
      const arrPoints = [];
      for (var i = 0; i < path.length; i++) {
        const _path = isFunction(path.getAt)
          ? [path.getAt(i).lng(), path.getAt(i).lat()]
          : [path[i].lng(), path[i].lat()];
        arrPoints.push(_path);
      }
      if (isFunction(path.getAt))
        arrPoints.push([path.getAt(0).lng(), path.getAt(0).lat()]);
      else arrPoints.push([path[0].lng(), path[0].lat()]);
      value = {
        coordinates: arrPoints,
      };
      obj.values.operator = "plotted_polygon";
      obj.values.values = JSON.stringify(value);
      break;
    case "address_radius":
      obj.attributeId = 90;
      obj.values.operator = "plotted_radius";
      value = {
        lat: plottedValues.center.lat,
        lng: plottedValues.center.lng,
        radius: plottedValues.radius,
      };
      obj.values.values = JSON.stringify(value);
      break;
    case "address_drive":
      obj.attributeId = 90;
      obj.values.operator = "drive_time";
      obj.values.operator = "plotted_radius";
      value = {
        lat: plottedValues.center.lat,
        lng: plottedValues.center.lng,
        radius: plottedValues.driveRadius,
      };
      obj.values.values = JSON.stringify(value);
      break;
    default:
      obj = null;
      break;
  }

  return obj;
};

export const parseZipcode = (data, segmentName) => {
  const newSegment = {
    segment: {
      name: segmentName,
      status: "Active",
      clientId: data.selected_client,
      createdUserId: 1,
      rawData: "",
    },
    rules: [],
  };
  const rawData = {
    name: segmentName,
    selected_segments: null,
    plotted_values: null,
    selected_city: null,
    selected_state: null,
    selected_county: null,
    selected_dma: null,
    zipcode: null,
  };
  const { zipcode, rules_id } = data;
  rawData.zipcode = zipcode;

  if (zipcode && zipcode.length > 0) {
    const zipcodeObj = {
      attributeId: 7,
      values: {
        operator: "matches",
        values: "",
      },
    };
    if (rules_id.length > 0) {
      rules_id.forEach((item) => {
        if (item.attributeId === 7) {
          zipcodeObj.id = item.id;
        }
      });
    }
    const zipcodeValues = [];
    map(zipcode, (item) => {
      zipcodeValues.push(item.zipcode);
    });
    zipcodeObj.values.values = zipcodeValues.join();
    newSegment.rules.push(zipcodeObj);
  }

  newSegment.segment.rawData = JSON.stringify(rawData);

  return newSegment;
};

export const getAttributeInfo = (id, demoAttributes) => {
  let result = null;
  map(demoAttributes, (cat, key) => {
    map(cat.attributes, (attr) => {
      if (attr.id === id) {
        result = attr;
        return;
      }

      map(attr.subAttributes, (subAttr) => {
        if (subAttr.id === id) {
          result = subAttr;
          return;
        }
      });
    });
  });

  return result;
};

export const attr2Rules = (selected_segments, demoAttributes, rules_id) => {
  const result = [];
  map(demoAttributes, (cat) => {
    map(cat.attributes, (attr) => {
      const attrObj = {
        attributeId: attr.id,
        values: {
          operator: "matches",
          values: "",
        },
      };
      if (rules_id.length > 0) {
        rules_id.forEach((item) => {
          if (item.attributeId === attr.id) {
            attrObj.id = item.id;
          }
        });
      }
      let attrVals = [];
      let attrParents = [];
      map(attr.values, (val) => {
        if (selected_segments.indexOf(val.id) >= 0) {
          if (attr.id === 606) {
            //auto model
            let labels = val.label.split(" - ");
            if (labels.length === 2) {
              attrParents.push(labels[0].toUpperCase());
            }
          }
          attrVals.push(val.value);
        }
      });
      map(attr.subAttributes, (sub_attr) => {
        const subAttrObj = {
          attributeId: sub_attr.id,
          //parentId: sub_attr.parentId,
          values: {
            operator: "matches",
            values: "",
          },
        };
        if (rules_id.length > 0) {
          rules_id.forEach((item) => {
            if (item.attributeId === sub_attr.id) {
              subAttrObj.id = item.id;
            }
          });
        }
        let subAttrVals = [];
        map(sub_attr.values, (val) => {
          if (selected_segments.indexOf(val.id) >= 0)
            subAttrVals.push(val.value);
        });
        if (subAttrVals.length > 0) {
          subAttrObj.values.values = subAttrVals.join();
          //newSegment.rules.push(subAttrObj)
          result.push(subAttrObj);
        }
      });
      if (attrVals.length > 0) {
        if (attr.id === 606) {
          attrObj.values["parents"] = attrParents;
        }
        attrObj.values.values = attrVals.join();
        //newSegment.rules.push(attrObj)
        result.push(attrObj);
      }
    });
  });
  return result;
};
export const parseSegment = (data, segmentName, state_plotted_values) => {
  const newSegment = {
    segment: {
      name: segmentName,
      status: "Active",
      clientId: data.selected_client,
      createdUserId: 1,
      rawData: "",
      targetHouseholdsOnly: Boolean(data.targetHouseholdsOnly),
    },
    rules: [],
  };
  const rawData = {
    name: segmentName,
    selected_segments: null,
    plotted_values: null,
    selected_city: null,
    selected_state: null,
    selected_dma: null,
    selected_county: null,
    zipcode: null,
  };
  const {
    selected_segments,
    demoAttributes,
    plotted_values,
    selected_state,
    selected_city,
    selected_dma,
    selected_county,
    zipcode,
    rules_id,
  } = data;
  const plottedValues = state_plotted_values
    ? state_plotted_values
    : plotted_values;
  rawData.selected_segments = selected_segments;
  rawData.plotted_values = plotted_values;
  rawData.selected_city = selected_city;
  rawData.selected_state =
    !isEmpty(selected_county) || !isEmpty(selected_dma) ? [] : selected_state;
  rawData.selected_county = selected_county;
  rawData.selected_dma = selected_dma;
  rawData.zipcode = zipcode;
  /*
	map(demoAttributes, (cat) => {
		map(cat.attributes, (attr) => {
			const attrObj = {
				attributeId: attr.id,
				values: {
					operator: "matches",
					values: ""
				}
			}
			if (rules_id.length > 0) {
				rules_id.forEach((item) => {
					if (item.attributeId === attr.id) {
						attrObj.id = item.id
					}
				})
			}
			let attrVals = []
			map(attr.values, (val) => {
				if (selected_segments.indexOf(val.id) >= 0)
					attrVals.push(val.value)
			})
			map(attr.subAttributes, (sub_attr) => {
				const subAttrObj = {
					attributeId: sub_attr.id,
					values: {
						operator: "matches",
						values: ""
					}
				}
				if (rules_id.length > 0) {
					rules_id.forEach((item) => {
						if (item.attributeId === sub_attr.id) {
							subAttrObj.id = item.id
						}
					})
				}
				let subAttrVals = []
				map(sub_attr.values, (val) => {
					if (selected_segments.indexOf(val.id) >= 0)
						subAttrVals.push(val.value)
				})
				if (subAttrVals.length > 0) {
					subAttrObj.values.values = subAttrVals.join()
					newSegment.rules.push(subAttrObj)
				}
			})
			if (attrVals.length > 0) {
				attrObj.values.values = attrVals.join()
				newSegment.rules.push(attrObj)
			}
		})
	})*/
  newSegment.rules = attr2Rules(selected_segments, demoAttributes, rules_id);

  if (
    selected_state &&
    selected_state.length > 0 &&
    isEmpty(selected_county) &&
    isEmpty(selected_dma)
  ) {
    const stateObj = {
      attributeId: 1,
      values: {
        operator: "matches",
        values: "",
      },
    };
    if (rules_id.length > 0) {
      rules_id.forEach((item) => {
        if (item.attributeId === 1) {
          stateObj.id = item.id;
        }
      });
    }
    const stateValues = [];
    map(selected_state, (state) => {
      stateValues.push(state.value);
    });
    stateObj.values.values = stateValues.join();
    newSegment.rules.push(stateObj);
  }

  if (selected_county && selected_county.length > 0) {
    const countyObj = {
      attributeId: 2,
      values: {
        operator: "matches",
        values: "",
      },
    };
    if (rules_id.length > 0) {
      rules_id.forEach((item) => {
        if (item.attributeId === 2) {
          countyObj.id = item.id;
        }
      });
    }
    const countyValues = [];
    map(selected_county, (county) => {
      countyValues.push(county.value);
    });
    countyObj.values.values = countyValues.join();
    newSegment.rules.push(countyObj);
  }

  if (selected_city && selected_city.length > 0) {
    const cityObj = {
      attributeId: 3,
      values: {
        operator: "matches",
        values: "",
        parents: [],
      },
    };
    if (rules_id.length > 0) {
      rules_id.forEach((item) => {
        if (item.attributeId === 3) {
          cityObj.id = item.id;
        }
      });
    }
    const cityValues = [];
    const states = [];
    map(selected_city, (city) => {
      cityValues.push(city.value);
      states.push(city.state);
    });
    cityObj.values.values = cityValues.join();
    cityObj.values.parents = states;
    newSegment.rules.push(cityObj);
  }

  if (selected_dma && selected_dma.length > 0) {
    const dmaObj = {
      attributeId: 4,
      values: {
        operator: "matches",
        values: "",
      },
    };
    if (rules_id.length > 0) {
      rules_id.forEach((item) => {
        if (item.attributeId === 4) {
          dmaObj.id = item.id;
        }
      });
    }
    const dmaValues = [];
    map(selected_dma, (dma) => {
      dmaValues.push(dma.value);
    });
    dmaObj.values.values = dmaValues.join();
    newSegment.rules.push(dmaObj);
  }
  if (zipcode && zipcode.length > 0) {
    const zipcodeObj = {
      attributeId: 7,
      values: {
        operator: "matches",
        values: "",
      },
    };
    if (rules_id.length > 0) {
      rules_id.forEach((item) => {
        if (item.attributeId === 7) {
          zipcodeObj.id = item.id;
        }
      });
    }
    const zipcodeValues = [];
    map(zipcode, (item) => {
      zipcodeValues.push(item.zipcode);
    });
    zipcodeObj.values.values = zipcodeValues.join();
    newSegment.rules.push(zipcodeObj);
  }
  if (plottedValues) {
    const obj = parsePlottedValues(plottedValues);
    if (obj) newSegment.rules.push(obj);
  }
  if (rawData.plotted_values && rawData.plotted_values.type === "polygon") {
    rawData.plotted_values.path = rawData.plotted_values.encode_path;
  }
  newSegment.segment.rawData = JSON.stringify(rawData); //JSON.stringify(rawData)

  if (data.segment_id !== "") {
    newSegment.segment.id = data.segment_id;
  }

  if (newSegment.rules.length === 1 && newSegment.rules[0] == null)
    newSegment.rules = [];

  return newSegment;
};

export const getLanguageGroup = (val) => {
  if (val.indexOf("HL") >= 0) {
    return "Hispanic Language Usage";
  }
  if (val.indexOf("AL_CN") >= 0) {
    return "Chinese Language Usage";
  }
  if (val.indexOf("AL_IN") >= 0) {
    return "Indic Language Usage";
  }
  if (val.indexOf("AL_JP") >= 0) {
    return "Japanese Language Usage";
  }
  if (val.indexOf("AL_VN") >= 0) {
    return "Vietnamese Language Usage";
  }
  if (val.indexOf("AL_KR") >= 0) {
    return "Korean Language Usage";
  }
  if (val.indexOf("HA") >= 0) {
    return "Hispanicity";
  }
  if (val.indexOf("AA") >= 0) {
    return "Asianicity";
  }

  return val;
};



// WEBPACK FOOTER //
// ./src/utils/segment_util.js